import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { CommentDtoType } from '../../../types/dto/CommentDtoType';
import { EntityType } from '../../../types/dto/EntityType';

type CommentsDataProviderProps = {
  userId: number;
  type: EntityType;
  linkedId: number;
  children?: any;
  onLoaded?: (items: CommentDtoType[]) => any;
};

async function fetchData(
  type: string,
  linkedId: number,
  userId: number,
  abortController: AbortController
) {
  const signal = abortController.signal;

  try {
    const response = await fetch('/api/comments', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        linkedId,
        userId,
        type
      }),
      signal: signal
    });

    return (await response.json()).comments;
  } catch (error) {
    if (abortController.signal.aborted) {
      console.log('The user aborted the request');
    } else {
      toast.success('Something went wrong, please try again later', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
  }
}

export function CommentsDataProvider({
  type,
  linkedId,
  userId,
  children,
  onLoaded
}: CommentsDataProviderProps) {
  useEffect(() => {
    const abortController = new AbortController();

    fetchData(type, linkedId, userId, abortController)
      .then(items => onLoaded?.(items))
      .catch(error => console.error(error));

    return () => abortController.abort();
  }, []);

  return <>{children}</>;
}
